import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import ArmsRum from '@arms/rum-browser'
import { ENABLE_ARMS } from './global/config'
import '@/style/scss/index.scss'

if (ENABLE_ARMS) {
  try {
    ArmsRum.init({
      pid: 'bcli3ygwq4@a486241d111ed77', // 请替换为实际的 PID
      endpoint: 'https://bcli3ygwq4-default-cn.rum.aliyuncs.com', // 请替换为实际的 Endpoint
      spaMode: 'auto',
      env: 'prod',
    })
  } catch (error) {
    console.error('ARMS initialization failed:', error)
  }
}

/* <React.StrictMode></React.StrictMode> 严格模式 */
ReactDOM.render(<App />, document.getElementById('root'))
// 模块热替换  yarn add @types/webpack-env
if (module.hot) {
  module.hot.accept()
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import ArmsRum from '@arms/rum-browser'
import { ENABLE_ARMS } from './global/config'
import '@/style/scss/index.scss'

if (ENABLE_ARMS) {
  try {
    ArmsRum.init({
      pid: 'bcli3ygwq4@a486241d111ed77', // 请替换为实际的 PID
      endpoint: 'https://bcli3ygwq4-default-cn.rum.aliyuncs.com', // 请替换为实际的 Endpoint
      spaMode: 'auto',
      env: 'prod',
    })
  } catch (error) {
    console.error('ARMS initialization failed:', error)
  }
}

/* <React.StrictMode></React.StrictMode> 严格模式 */
ReactDOM.render(<App />, document.getElementById('root'))
// 模块热替换  yarn add @types/webpack-env
if (module.hot) {
  module.hot.accept()
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
